var map = {
	"./step-1012.png": "mjCf",
	"./step-102.png": "w5v1",
	"./step-1022.png": "H+3I",
	"./step-1032.png": "TUVe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BOpj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery ^\.\/step\-10.*2\.png$
// module id = BOpj
// module chunks = 1